import { render, staticRenderFns } from "./ReceiveOrderDetail.vue?vue&type=template&id=799f716a&"
import script from "./ReceiveOrderDetail.vue?vue&type=script&lang=js&"
export * from "./ReceiveOrderDetail.vue?vue&type=script&lang=js&"
import style0 from "./ReceiveOrderDetail.vue?vue&type=style&index=0&lang=stylus&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports